import React, { useState, useEffect, useCallback } from "react";
import CustomButton from "../../../atoms/CustomButton";
import Import from "../../../icons/Import";
import Filter from "../../../icons/Filter";
import CustomDataGrid from "../../../organisms/CustomDatagrid";
import Modal from "../../../organisms/modals/Modal";
import CustomMenu from "../../../atoms/CustomMenu";
import { v4 as uuidv4 } from "uuid";
import View from "../../../icons/View";
import Edit from "../../../icons/Edit";
import Delete from "../../../icons/Delete";
import VerticalMenu from "../../../icons/VerticalMenu";
import { getData, deleteData } from "../../../../services";
import { useCookies } from "react-cookie";
import Form from "./Form";
import Pagination from "../../../molecules/Pagination";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import Search from "../../../molecules/search";
import SideOverlay from "../../../atoms/SideOverlay";
import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
  getTeamsList,
} from "../../../../services/basicGets";
import {
  errorStyles,
  confimationStyles,
} from "../../../../assets/styles/toast";
import toast from "react-hot-toast";
import NoContentCard from "../../../atoms/NoContentCard";
import { useSelector } from "react-redux";
import { Select, MenuItem, Tooltip } from "@mui/material";

const EmployeeManagement = () => {
  const [cookies] = useCookies([]);
  const [selectedRow, setSelectedRow] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchedValue, setSearchedValue] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [department, setDepartment] = useState([]);
  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
  });

  //access details handling
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const employeeAccess =
    accessData?.access?.find(
      (module) => module.module === "Employee Management"
    ) || {};
  const isAdmin = accessData?.role?.label === "Admin";

  const canCreate = isAdmin || employeeAccess?.is_create;
  const canEdit = isAdmin || employeeAccess?.is_edit;
  const canDelete = isAdmin || employeeAccess?.is_delete;

  useEffect(() => {
    (async () => {
      const resEmployee = await getEmployeeList({
        token: cookies.e_t,
      });

      const resRoles = await getRolesList({
        token: cookies.e_t,
      });

      const resDepartments = await getdepartmentList({
        token: cookies.e_t,
      });

      const resTeams = await getTeamsList({
        token: cookies.e_t,
      });

      setTeams(resTeams.data.teams);
      setRoles(resRoles);
      setDepartment(resDepartments);
      setEmployees(resEmployee?.employeeResponseValueLabel);
    })();
  }, []);

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "Employee/GetAllEmployees",
        params: {
          search_query: searchedValue,
          page: currentPage,
          page_limit: itemsPerPage,
          employee_id : isAdmin ? null : cookies.euid,
          // business_id: cookies.bid,
        },
        token: cookies.e_t,
      });
      if (res) {
        setTableData(res?.data);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    } finally {
      setIsLoading(false)
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  //handling menu
  const menu = [
    canEdit && {
      icon: <Edit height="20" width="20" />,
      label: "Edit",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    canDelete && cookies.euid !== selectedRow?.id && {
      icon: <Delete />,
      label: "Delete",
      onClick: () => {
        setAnchorEl(null);
        handleDeleteModal(selectedRow);
      },
    },
  ].filter(Boolean);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
      email: data.email,
    }));
  };

  const handleDeletion = async () => {
    try {
      await deleteData({
        endpoint: "Employee/DeleteEmployee",
        params: {
          name: modalState.name,
          email: modalState.email,
        },
        token:cookies.e_t
      });
      getUserData();

      toast.success("Employee Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
    } catch (error) {
      toast.error("An Error Occured", {
        style: errorStyles,
        duration: 1000,
      });
      console.log(error);
    } finally {
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    }
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Employee",
    }));
  };

  const columns = [
    {
      field: "emp_id",
      headerName: "Emp. ID",
      flex: 1,
      sortable: true,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => {

        let paramsdata = params.value

        return (
          <Tooltip title={paramsdata} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => canEdit && handleEdit(params.row)}
            >
              {paramsdata}
            </span>
          </Tooltip>
        );
        // <div 
        //   style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', cursor: canEdit ? 'pointer' : 'default' }}
        //   onClick={() => canEdit && handleEdit(params.row)}
        // >
        //   {params.value}
        // </div>
      }
    },
    {
      field: "role_name",
      headerName: "Role",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div 
          style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', cursor: canEdit ? 'pointer' : 'default' }}
          onClick={() => canEdit && handleEdit(params.row)}
        >
          {params.value}
        </div>
      )
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div 
          style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' , cursor: canEdit ? 'pointer' : 'default' }}
          onClick={() => canEdit && handleEdit(params.row)}
        >
          {params.value}
        </div>
      )
    },
    ...(canEdit || canDelete
      ? [
          {
            field: "actions",
            headerName: "",
            flex: 0.2,
            renderCell: (params) => {
              return (
                <div className="table-icons-container">
                  <div onClick={(event) => handleStatusMenu(event, params.row)}>
                    <VerticalMenu />
                  </div>
  
                  <CustomMenu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    items={menu}
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = () => {
    // if(type === 'submitted'){
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // } else {
    //   // setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    //   setIsFormDirty(true)
    //   setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // }
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        {/* {!!searchedValue ? (
          <NoContentCard
            title="No Record Found"
            type="Company"
            icon={<NoContentIcon />}
            small={true}
          />
        ) : ( */}
        <NoContentCard
          title="No Employees Found"
          type="Employee"
         
        />
        {/* )} */}
      </>
    );
  });

  return (
    <div id="Employee-Management" className="main-container">
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          <Search
            placeholder="Search"
            onSearchEmit={(item) => {
              if (currentPage !== 1) {
                setCurrentPage(1);
              }
              setSearchedValue(item);
            }}
          />
        </div>
        <div className="d-flex gap-2">
          {canCreate && (
            <CustomButton
              text="Create Employee"
              type="btn-primary"
              handleClick={() => openModal("Create Employee")}
            />
          )}
        </div>
      </div>
      <div className="mt-3">
        <CustomDataGrid
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.employeeResponse || []}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params) => {
            if (params.field !== "actions" && canEdit) {
              handleEdit(params.row);
            }
          }}
          canEdit={canEdit}
        />
      </div>

      {tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {/* {modalState?.isModalOpen && (
        <Modal
          id={modalState?.modalId}
          title={modalState.title}
          isActive={modalState?.isModalOpen}
          onClose={closeModal}
          takeConfirmation={isFormDirty ? true : false}
          width="650px"
        >
          <Form
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "Edit Employee" ? modalState.modalData : null
            }
            refetchData={getUserData}
            onClose={() => closeModal("submit")}
          />
        </Modal>
      )} */}

      {modalState?.isModalOpen && (
        <SideOverlay
          id={modalState?.modalId}
          title={modalState.title}
          onClose={closeModal}
          isOpen={modalState?.isModalOpen}
          side="right"
          width="650px"
        >
          <Form
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "Edit Employee" ? modalState.modalData : null
            }
            refetchData={getUserData}
            onClose={() => closeModal("submit")}
            teamsList={teams}
            employeeList={employees}
            departmentList={department}
            rolesList={roles}
            isAdmin = {isAdmin}
          />
        </SideOverlay>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="Employee"
          onClick={handleDeletion}
        />
      )}
    </div>
  );
};

export default EmployeeManagement;
